import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const small = props => {
  const { text, icon, onClick } = props;

  return (
    <div className="action-button small" onClick={onClick}>
      {icon}{text}
    </div>
  );
};

small.defaultProps = {
  onClick: () => null,
};

small.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  onClick: PropTypes.func,
};

export default small;
